export default __webpack_public_path__ + "images/HY.6187433.png";